import React, {FC} from 'react';

/** 使用指南「主图/详情图生成」tab 英文正文，元素结构与 zh.tsx 1:1 对应。 */
const EnContent: FC = () => {
  return (
    <>
      <h2>Main & Detail Image Generation</h2>
      <p>
        No prompts needed — upload a product photo or paste a product link, and AI generates main images, secondary
        images, and full detail-page sets that match platform specs, covering Amazon, Ozon, Coupang, Rakuten, Temu and
        other major platforms.
      </p>

      <h3>1. Upload a product photo or paste a product link</h3>
      <p>
        Two input methods are supported: upload a real product photo or a white-background image directly, or paste a
        product link and let the system automatically capture the main image as the generation source.
      </p>

      <h3>2. AI identifies the product and generates visuals</h3>
      <p>
        AI automatically identifies the product, builds the scene, and extracts selling points to generate main and
        detail images matching your chosen platform's specs — each image type has a different job:
      </p>
      <ul>
        <li>
          Main images make shoppers "stop": they build a first impression fast in search, recommendations, and listing
          pages, deciding whether a shopper clicks in.
        </li>
        <li>
          Detail images make shoppers "stay": through selling points, usage scenes, and trust-building, they resolve
          doubts and drive the shopper to purchase.
        </li>
      </ul>

      <h3>3. Choose a visual style for your target market</h3>
      <p>Five built-in market styles are available, so you don't need to guess local aesthetics on your own:</p>
      <ul>
        <li>
          North America/Europe (Amazon): brand-driven, rational, premium lifestyle — restrained layout, strong photo
          quality, clear information hierarchy.
        </li>
        <li>
          Japan: emotionally descriptive, strongly persuasive — bold headlines and slogans, busy but clearly organized
          information.
        </li>
        <li>
          Korea (Coupang): lifestyle-driven, gentle and relatable — strong scene presence, restrained text, soft mood.
        </li>
        <li>
          Russia (Ozon): strongly conversion-driven, direct persuasion — bold headlines, bold color blocks, dense icon
          labels.
        </li>
        <li>
          Southeast Asia: strong promotional feel, visual marketing style — vibrant colors, clear promotional
          atmosphere.
        </li>
      </ul>

      <h3>4. Preview before generating the full-resolution version</h3>
      <p>
        Preview the result before committing — previews cost only <strong>¥0.4 per set</strong>. Once you're happy with
        the result, generate the full high-resolution set to avoid wasting credits.
      </p>

      <h3>5. Download and use</h3>
      <p>
        Once generation is complete, download all images directly and upload them to your platform's main image and
        detail page fields.
      </p>
    </>
  );
};

export default EnContent;
